<div class="count">
  <div class="decks">
    <i class="fui-exit" (click)="logout()"></i>
    <div class="top">
      <h2>FlashReview</h2>

      <div class="button-top">
        <button class="but" (click)="openNewFolderModal()">Nova Pasta</button>
        <button class="but" (click)="goToCreate()">Novo Deck</button>
        <!-- <button class="but">Editar Deck</button> -->
        <button class="but" (click)="openImportDeckModal()">Importar Deck</button>
        <!-- <button class="but" (click)="logout()">Sair</button> -->
      </div>

      <div class="mobile-navbar">
        <i class="fui-list" (click)="toggleSidebar()"> </i>
      </div>
    </div>
    @for (folder of folders; track folder.name) {
      <div class="acc">
        <div class="folder">
          <div class="folder-header" [class.open]="folder.open" (click)="toggleFolder(folder); $event.stopPropagation()">
            {{ folder.name }}
          </div>

          <div class="deck-list" [@accordion]="folder.open ? 'open' : 'closed'">
            @for (deck of folder.decks; track deck.id) {
              <div class="div">
                <div class="deck" (click)="openDeck(deck.id)">
                  {{ deck.name }}
                </div>
                <div class="fui">
                  <!-- <i class="fui-new" (click)="goToEditDeck(deck.id); $event.stopPropagation()"></i>
                  <i class="fui-cross" (click)="openDeleteDeckModal(deck); $event.stopPropagation()"></i> -->

                  <ion-icon name="pencil" (click)="goToEditDeck(deck.id); $event.stopPropagation()"></ion-icon>
                  <ion-icon name="close"   (click)="openDeleteDeckModal(deck); $event.stopPropagation()"></ion-icon>
                </div>
              </div>
            }
          </div>
        </div> 
 
        <div class="fuia">
          <!-- <i class="fui-new" (click)="openEditFolderModal(folder)"></i> -->
          <!-- <i class="fui-cross" (click)="openDeleteFolderModal(folder)"></i> -->
          <ion-icon name="pencil" (click)="openEditFolderModal(folder)"></ion-icon>
          <ion-icon name="close"   (click)="openDeleteFolderModal(folder)"></ion-icon>
        </div>
      </div>
    }
  </div>
</div>

@if (showModal) {
  <div class="modal" (click)="closeModal()">
    <app-mode-modal (selected)="onModeSelected($event)" (click)="$event.stopPropagation()">
    </app-mode-modal>
  </div>
}

@if (showModalNewFolder) {
  <div class="modal" (click)="closeNewFolderModal()">
    <!-- Adicionado o (created)="onFolderCreated($event)" -->
    <app-new-folder-modal 
      (created)="onFolderCreated($event)" 
      (click)="$event.stopPropagation()"> 
    </app-new-folder-modal>
  </div>
}

@if (showEditFolderModal) {
  <div class="modal" (click)="closeEditFolderModal()">
   <app-edit-folder-modal 
      [folderName]="folderToEdit.name" 
      (edited)="onFolderEdited($event)">
    </app-edit-folder-modal>
  </div>
}

@if (showDeleteFolderModal) {
  <div class="modal" (click)="closeDeleteFolderModal()">
    <app-delete-folder-modal 
      [folderName]="folderToDelete.name" 
      (confirmed)="onFolderDeleted($event)">
    </app-delete-folder-modal>
  </div>
}

@if (showDeleteDeckModal) {
  <!-- Tem que ser EXATAMENTE igual ao selector do passo 1 -->
  <div class="modal" (click)="closeDeleteDeckModal()">
    <app-delete-deck-modal 
      [deckName]="deckToDelete.name" 
      (confirmed)="onDeckDeleted($event)">
    </app-delete-deck-modal>
  </div>
}

@if (showImportDeckModal) {
  <div class="modal" (click)="closeImportDeckModal()">
    <app-import-deck-modal (imported)="onDeckImported($event)"> </app-import-deck-modal>
  </div>
}

@if (sidebarOpen) {
  <div class="sidebar-overlay" (click)="toggleSidebar()">
    <div class="sidebar" (click)="$event.stopPropagation()">
      <button class="but" (click)="openNewFolderModal()">Nova Pasta</button>

      <button class="but" (click)="goToCreate()">Novo Deck</button>

      <button class="but" (click)="openImportDeckModal()">Importar Deck</button>
    </div>
  </div>
}
